import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "ui";

import { DriverFormAtomProps } from "../DriverDetailsForm.types";

import styles from "../DriverDetailsForm.module.scss";

const PasswordFields = ({ control }: DriverFormAtomProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.driverForm__block__inputs}>
      <Controller
        control={control}
        name={"password"}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            value={value}
            onChange={onChange}
            label={t("Password")}
            errorMessage={error?.message}
            data-testid="driver--password"
            isPassword
          />
        )}
      />
      <Controller
        control={control}
        name={"repeatPassword"}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            value={value}
            onChange={onChange}
            label={t("Repeat Password")}
            errorMessage={error?.message}
            data-testid="driver--repeatPassword"
            isPassword
          />
        )}
      />
    </div>
  );
};
export default PasswordFields;
